module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-pa003.cfb08452.png";